import React from 'react'
import { useIndex, useValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function CleaningCategorySectionTabs () {
  const index = useIndex()

  const [activeSection, setActiveSection] = useEnvValue('cleaning_checkup.active_section', null)

  const categoryId = useValue('category_id')

  const changeSection = () => {
    setActiveSection(categoryId)
  }

  function checkIfActive () {
    if (activeSection) {
      return activeSection === categoryId
    }

    return index === 0
  }

  function getActiveClass (isActive) {
    return isActive ? 'active' : ''
  }

  const [isActive, setIsActive] = React.useState(checkIfActive(index, activeSection))

  React.useEffect(() => {
    setIsActive(checkIfActive(index, activeSection))
  }, [index, activeSection])

  return (
    <div onClick={changeSection} className={'tab-btn ' + getActiveClass(isActive)}>
      <Displays.Text name='category_name' />
    </div>
  )
}
